import React, { Component } from 'react';
import moment from 'moment';


import { Form, Input, Button, Modal, InputNumber, TimePicker, Switch, Icon, Divider, Checkbox, Row, Col } from 'antd';

const FormItem = Form.Item;

class PlaceRolesForm extends Component {

  state = {
    modalVisible: false,
    mondayDisabled: false,
    tuesdayDisabled: false,
    wednesdayDisabled: false,
    thursdayDisabled: false,
    fridayDisabled: false,
    saturdayDisabled: false,
    sundayDisabled: false,
    mondayTimes: [{
      from: 0,
      to: 1440
    }],
    tuesdayTimes: [{
      from: 0,
      to: 1440
    }],
    wednesdayTimes: [{
      from: 0,
      to: 1440
    }],
    thursdayTimes: [{
      from: 0,
      to: 1440
    }],
    fridayTimes: [{
      from: 0,
      to: 1440
    }],
    saturdayTimes: [{
      from: 0,
      to: 1440
    }],
    sundayTimes: [{
      from: 0,
      to: 1440
    }]
  }

  form = null;

  componentDidUpdate(prevProps) {
    if (this.props.initialValues && this.props.initialValues !== prevProps.initialValues) {
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 1) !== -1) {
        this.setState({ mondayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 1)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 2) !== -1) {
        this.setState({ tuesdayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 2)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 3) !== -1) {
        this.setState({ wednesdayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 3)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 4) !== -1) {
        this.setState({ thursdayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 4)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 5) !== -1) {
        this.setState({ fridayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 5)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 6) !== -1) {
        this.setState({ saturdayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 6)].times })
      }
      if (this.props.initialValues.activeHours.findIndex(item => item.weekday === 7) !== -1) {
        this.setState({ sundayTimes: this.props.initialValues.activeHours[this.props.initialValues.activeHours.findIndex(item => item.weekday === 7)].times })
      }

      this.setState({ mondayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 1) !== -1 ? false : true });
      this.setState({ tuesdayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 2) !== -1 ? false : true });
      this.setState({ wednesdayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 3) !== -1 ? false : true });
      this.setState({ thursdayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 4) !== -1 ? false : true });
      this.setState({ fridayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 5) !== -1 ? false : true });
      this.setState({ saturdayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 6) !== -1 ? false : true });
      this.setState({ sundayDisabled: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 7) !== -1 ? false : true });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }
  handleCheckboxChange = (day) => {
    const isTimePickerDisabled = !this.state[`${day}Disabled`]
    this.setState({ [`${day}Disabled`]: isTimePickerDisabled });
  };

  handleTimesArray = (from, to) => {
    var array = [];
    from.map((item, index) => {
      array.push({ from: moment(from[index]).diff(moment().startOf('day'), 'minutes'), to: moment(to[index]).diff(moment().startOf('day'), 'minutes') === 1439 ? 1440 : moment(to[index]).diff(moment().startOf('day'), 'minutes') })
    })
    return array;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        var activeHours = [];
        if (values.monday) {
          let mondayTimes = this.handleTimesArray(values.mondayTimesFrom, values.mondayTimesTo);
          activeHours.push({ weekday: 1, times: mondayTimes })
        }
        if (values.tuesday) {
          let tuesdayTimes = this.handleTimesArray(values.tuesdayTimesFrom, values.tuesdayTimesTo);
          activeHours.push({ weekday: 2, times: tuesdayTimes })
        }
        if (values.wednesday) {
          let wednesdayTimes = this.handleTimesArray(values.wednesdayTimesFrom, values.wednesdayTimesTo);
          activeHours.push({ weekday: 3, times: wednesdayTimes })
        }
        if (values.thursday) {
          let thursdayTimes = this.handleTimesArray(values.thursdayTimesFrom, values.thursdayTimesTo);
          activeHours.push({ weekday: 4, times: thursdayTimes })
        }
        if (values.friday) {
          let fridayTimes = this.handleTimesArray(values.fridayTimesFrom, values.fridayTimesTo);
          activeHours.push({ weekday: 5, times: fridayTimes })
        }
        if (values.saturday) {
          let saturdayTimes = this.handleTimesArray(values.saturdayTimesFrom, values.saturdayTimesTo);
          activeHours.push({ weekday: 6, times: saturdayTimes })
        }
        if (values.sunday) {
          let sundayyTimes = this.handleTimesArray(values.sundayTimesFrom, values.sundayTimesTo);
          activeHours.push({ weekday: 7, times: sundayyTimes })
        }
        delete values.monday;
        delete values.mondayTimesFrom;
        delete values.mondayTimesTo;
        delete values.tuesday;
        delete values.tuesdayTimesFrom;
        delete values.tuesdayTimesTo;
        delete values.wednesday;
        delete values.wednesdayTimesFrom;
        delete values.wednesdayTimesTo;
        delete values.thursday;
        delete values.thursdayTimesFrom;
        delete values.thursdayTimesTo;
        delete values.friday;
        delete values.fridayTimesFrom;
        delete values.fridayTimesTo;
        delete values.saturday;
        delete values.saturdayTimesFrom;
        delete values.saturdayTimesTo;
        delete values.sunday;
        delete values.sundayTimesFrom;
        delete values.sundayTimesTo
        values.activeHours = activeHours;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }
  validateTimeFromTo = (rule, value, callback, from) => {
    const form = this.props.form;
    const fromValue = moment(form.getFieldValue(from)).diff(moment().startOf('day'), 'minutes')
    const toValue = moment(value).diff(moment().startOf('day'), 'minutes')
    if (fromValue >= toValue) {
      callback('Čas "Od" musí být menší než čas "Do".');
    } else {
      callback();
    }
  };
  handleAddTimeRange = (day) => {
    if (this.state[`${day}Times`].length < 3) {
      const newTimeRanges = [...this.state[`${day}Times`]];
      newTimeRanges.push({
        from: 0,
        to: 1440,
      });
      this.setState({ [`${day}Times`]: newTimeRanges });
    }
  };

  handleRemoveTimeRange = (index, day) => {
    const newTimeRanges = [...this.state[`${day}Times`]];
    newTimeRanges.splice(index, 1);
    this.setState({ [`${day}Times`]: newTimeRanges });
  };

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Kód" >
          {getFieldDecorator('code', {
            initialValue: this.props.initialValues && this.props.initialValues.code
              ? this.props.initialValues.code
              : '',
            rules: [{
              type: 'string', message: 'Položka musí obsahovat řetězec!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Název">
          {getFieldDecorator('name', {
            initialValue: this.props.initialValues && this.props.initialValues.name
              ? this.props.initialValues.name
              : '',
            rules: [{
              type: 'string', message: 'Položka musí obsahovat řetězec!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <Divider />
        <center><b>Aktivní ve dnech a časech</b></center>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('monday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 1) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('monday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Pondělí</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.mondayTimes.map((mondayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`mondayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours
                        ? moment().startOf('day').add(this.state.mondayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.mondayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`mondayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 1) != -1
                        ? moment().startOf('day').add(this.state.mondayTimes[index].to == 1440 ? 1439 : this.state.mondayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `mondayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.mondayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'monday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('monday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('tuesday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 2) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('tuesday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Úterý</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.tuesdayTimes.map((tuesdayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`tuesdayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 2) != -1
                        ? moment().startOf('day').add(this.state.tuesdayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.tuesdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`tuesdayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 2) != -1
                        ? moment().startOf('day').add(this.state.tuesdayTimes[index].to == 1440 ? 1439 : this.state.tuesdayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `tuesdayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.tuesdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'tuesday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('tuesday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('wednesday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 3) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('wednesday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Středa</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.wednesdayTimes.map((wednesdayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`wednesdayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 3) != -1
                        ? moment().startOf('day').add(this.state.wednesdayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.tuesdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`wednesdayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 3) != -1
                        ? moment().startOf('day').add(this.state.wednesdayTimes[index].to == 1440 ? 1439 : this.state.wednesdayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `wednesdayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.wednesdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'wednesday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('wednesday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('thursday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 4) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('thursday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Čtvrtek</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.thursdayTimes.map((thursdayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`thursdayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 4) != -1
                        ? moment().startOf('day').add(this.state.thursdayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.thursdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`thursdayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 4) != -1
                        ? moment().startOf('day').add(this.state.thursdayTimes[index].to == 1440 ? 1439 : this.state.thursdayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `thursdayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.thursdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'thursday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('thursday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('friday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 5) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('friday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Pátek</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.fridayTimes.map((fridayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`fridayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 5) != -1
                        ? moment().startOf('day').add(this.state.fridayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.fridayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`fridayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 5) != -1
                        ? moment().startOf('day').add(this.state.fridayTimes[index].to == 1440 ? 1439 : this.state.fridayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `fridayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.fridayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'friday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('friday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('saturday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 6) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('saturday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Sobota</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.saturdayTimes.map((saturdayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`saturdayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 6) != -1
                        ? moment().startOf('day').add(this.state.saturdayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.saturdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`saturdayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 6) != -1
                        ? moment().startOf('day').add(this.state.saturdayTimes[index].to == 1440 ? 1439 : this.state.saturdayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `saturdayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.saturdayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'saturday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('saturday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Row gutter={9} style={{ display: 'flex', justifyContent: 'center' }}>
          <Col span={6}>
            <FormItem
              {...formItemLayout}
            >
              {getFieldDecorator('sunday', {
                valuePropName: 'checked',
                initialValue: this.props.initialValues && this.props.initialValues.activeHours
                  ? this.props.initialValues.activeHours.findIndex(item => item.weekday === 7) != -1 ? true : false
                  : true,
              })(
                <Checkbox onChange={() => this.handleCheckboxChange('sunday')} />
              )}
              <span style={{ marginLeft: '8px' }}>Neděle</span>
            </FormItem>
          </Col>
          <Col>
            {this.state.sundayTimes.map((sundayRange, index) => (
              <React.Fragment key={index}>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" od:"
                  >
                    {getFieldDecorator(`sundayTimesFrom[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 7) != -1
                        ? moment().startOf('day').add(this.state.sundayTimes[index].from, 'minutes')
                        : moment('00:00', 'HH:mm'),
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.sundayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={11}>
                  <FormItem
                    {...formItemLayout}
                    label=" do:"
                  >
                    {getFieldDecorator(`sundayTimesTo[${index}]`, {
                      initialValue: this.props.initialValues && this.props.initialValues.activeHours.findIndex(item => item.weekday === 7) != -1
                        ? moment().startOf('day').add(this.state.sundayTimes[index].to == 1440 ? 1439 : this.state.sundayTimes[index].to, 'minutes')
                        : moment('23:59', 'HH:mm'),
                      rules: [
                        {
                          validator: (rule, value, callback) => this.validateTimeFromTo(rule, value, callback, `sundayTimesFrom[${index}]`),
                        },
                      ],
                    })(
                      <TimePicker format='HH:mm' disabled={this.state.sundayDisabled} />
                    )}
                  </FormItem>
                </Col>
                <Col span={1} style={{ display: 'flex', alignItems: 'center' }}>
                  {index != 0 &&
                    (
                      <div style={{ margin: '10px 0' }}>
                        <Icon
                          type="minus-circle-o"
                          onClick={() => this.handleRemoveTimeRange(index, 'sunday')}
                        />
                      </div>
                    )}
                </Col>
              </React.Fragment>
            ))}
            <Button type="dashed" onClick={() => this.handleAddTimeRange('sunday')}>
              Přidat časový rozsah
            </Button>
          </Col>
        </Row>
        <Divider />

        <FormItem
          {...formItemLayout}
          label="Státní svátky" >
          {getFieldDecorator('holidays', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.holidays
              ? this.props.initialValues.holidays
              : false,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Priorita" >
          {getFieldDecorator('priority', {
            initialValue: this.props.initialValues && this.props.initialValues.priority
              ? this.props.initialValues.priority
              : 1,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber min={1} max={999} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Aktivní" >
          {getFieldDecorator('active', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.active
              ? this.props.initialValues.active
              : false,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues
            ?
            <Button type="primary" htmlType="submit">Uložit</Button>
            :
            <Button type="primary" htmlType="submit">Vložit</Button>
          }
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={650}
          title={this.props.initialValues ? "Nastavení role parkovacího místa" : "Vytvoření role parkovacího místa"}
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false, modalVisible: false, mondayDisabled: false, tuesdayDisabled: false, wednesdayDisabled: false, thursdayDisabled: false, fridayDisabled: false, saturdayDisabled: false, sundayDisabled: false, });
          }}
          footer={<p></p>}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(PlaceRolesForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/PlaceRolesForm.js